export const LOGIN_ERROR_MESSAGE = 'Incorrect username or password';
export const LOGIN_NON_SPAREMIN_ERROR_MESSAGE =
  'Incorrect password, please try the social buttons above instead.';
export const GENERIC_ERROR_MESSAGE = 'Error logging in';
